'use client'

import { memo } from 'react'
import { IconSwitch3 } from '@tabler/icons-react'

import Button from 'shared/ui/Button'

import SubstitutesByDeliveryMethodModal from '../../substitutes/components/SubstitutesByDeliveryMethodModal'
import SubstitutesModal from '../../substitutes/components/SubstitutesModal'

import styles from './ProductAvailability.module.scss'

interface ProductAvailabilityProps {
  type: 'replacements' | 'not-available' | 'not-available-in-delivery-method'
  hasWeeklyAvailabilityPlan?: boolean
  weeklyAvailabilityPlan?: {
    [key: string]: boolean
  }
  isAvailableForDeliverySlot?: boolean
  unavailableLabel?: string
}
const ProductAvailability = memo(
  ({
    type = 'replacements',
    hasWeeklyAvailabilityPlan,
    weeklyAvailabilityPlan,
    isAvailableForDeliverySlot
  }: ProductAvailabilityProps) => {
    switch (type) {
      case 'replacements':
        if (
          !hasWeeklyAvailabilityPlan ||
          !weeklyAvailabilityPlan ||
          !isAvailableForDeliverySlot
        )
          return null

        return (
          <div className={styles.deliveryAvailability}>
            {!isAvailableForDeliverySlot && (
              <div className={styles.modalWrapper}>
                <SubstitutesModal
                  trigger={
                    <Button
                      id='cart_show_replacements_button'
                      startIcon={<IconSwitch3 />}
                      variant='primary'
                    >
                      Pokaż zamienniki
                    </Button>
                  }
                />
              </div>
            )}
          </div>
        )
      case 'not-available':
        return (
          <div className={styles.deliveryAvailability}>
            <p className={styles.paragraph}>
              Produkt niedostępny
            </p>
            <SubstitutesModal
              trigger={
                <Button
                  id='cart_show_replacements_button'
                  startIcon={<IconSwitch3 />}
                  variant='neutralOutline'
                >
                  Pokaż zamienniki
                </Button>
              }
            />
          </div>
        )
      case 'not-available-in-delivery-method':
        return (
          <div className={styles.deliveryAvailability}>
            <p className={styles.paragraph}>
              Produkt niedostępny dla wybranej metody dostawy
            </p>
            <SubstitutesByDeliveryMethodModal
              customProducts={false}
              trigger={
                <Button
                  id='cart_show_replacements_button'
                  startIcon={<IconSwitch3 />}
                  variant='neutralOutline'
                >
                  Pokaż zamienniki
                </Button>
              }
              deliveryMethodId={null}
            />
          </div>
        )
      default:
        return null
    }
  }
)

export default ProductAvailability
